import React from "react"
import { ReactComponent as BasicBadge } from "../images/badge-basic.svg"
import { ReactComponent as SupporterBadge } from "../images/badge-supporter.svg"
import { cn } from "./utils"

export default function MembershipBadge({
  membershipType,
  className = "",
  ...props
}) {
  if (membershipType === "basic")
    return (
      <BasicBadge className={cn("text-transparent", className)} {...props} />
    )
  if (membershipType === "supporter")
    return (
      <SupporterBadge
        className={cn("text-transparent", className)}
        {...props}
      />
    )
  return null
}
